module.exports = __webpack_public_path__ + "img/H1.bac1b3fa.png";